<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="912px"
    title="附件列表"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <div class="header">
        <el-upload
          class="upload-demo"
          :action="`/api/SystemFile/uploadFile?source=12&summaryId=${rowData.id}`"
          :data="{ source: 12, summaryId: rowData.id }"
          :headers="headers"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :show-file-list="false"
        >
          <div class="upload flex_c_c">
            <img src="@/assets/images/bill/upload-1.png" alt="" />
            选择文件上传
          </div>
        </el-upload>
      </div>
      <div class="data">
        <BaseTable
          :tableData="tableData"
          height="360"
          :boreder="true"
          :isPager="false"
        >
          <div slot="opt" slot-scope="row" class="optbtn">
            <div class="btn" @click="deleteRow(row.scope)">
              <i class="el-icon-delete"></i>删除
            </div>
            <div class="btn" @click="check(row.scope)">
              <i class="el-icon-zoom-in"></i>查看
            </div>
            <div class="btn" @click="download(row.scope)">
              <img src="@/assets/images/bill/download.png" alt="" />下载
            </div>
          </div>
        </BaseTable>
        <div class="footer">*暂时只支持图片和PDF查看</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import config from '@/utils/config'
import {
  getFileList,
  deleteSystemFile,
  downLoadFile
} from '@/api/setting'
export default {
  components: {
    BaseTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      config,
      tableData: {
        fileds: [
          {
            filed: 'fileName',
            label: '文件名',
            align: 'left',
            width: 383
          },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: 150,
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 3)
                : ''
          },
          {
            filed: 'createdName',
            label: '上传人',
            width: 100
          },
          {
            filed: 'opt',
            label: '操作',
            isCustom: true,
            width: 198
          }
        ],
        columns: []
      },
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getFileList()
      }
    }
  },
  methods: {
    async getFileList() {
      try {
        const params = {
          summaryId: this.rowData.id
        }
        const res = await getFileList(params)
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    handleSuccess(e) {
      if (e.success) {
        this.getFileList()
        this.$emit('ok')
        this.$message.success(e.errorMessage)
      } else {
        this.$message.error(e.errorMessage)
      }
    },
    beforeUpload(file) {
      const suffix = file.name.slice(
        file.name.lastIndexOf('.') + 1,
        file.name.length
      )
      if (!(suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png' || suffix === 'pdf')) {
        this.$message.error('请上传图片或pdf文件')
        return false
      }
    },
    check(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      ).toLowerCase()
      if (
        suffix.toLowerCase() === 'jpg' ||
        suffix.toLowerCase() === 'jpeg' ||
        suffix.toLowerCase() === 'png'
      ) {
        this.$viewerApi({
          images: [item.filePath]
        })
      } else if (suffix.toLowerCase() === 'pdf') {
        window.open(
          item.filePath
        )
      } else {
        this.$message('暂时只支持图片和PDF查看')
      }
    },
    async download(v) {
      try {
        const res = await downLoadFile({ guid: v.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    async deleteRow(row) {
      try {
        const res = await deleteSystemFile({ fileId: row.id })
        if (res.success) {
          this.getFileList()
          this.$emit('ok')
          this.$message.success(res.errorMessage)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding-top: 0;
}
/deep/ .el-dialog__header {
  border: 0;
}
.content {
  width: calc(100% - 40px);
  margin: 0 auto;
  .header {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 48px;
    .upload {
      width: 140px;
      height: 32px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #2395F3;
      box-sizing: border-box;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #2395F3;
    }
  }
  .data {
    width: 100%;
    .optbtn {
      display: flex;
      justify-content: space-around;
      .btn {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #2395f3;
        cursor: pointer;
        img {
          margin-right: 4px;
        }
        i {
          font-size: 18px;
          margin-right: 4px;
        }
      }
    }
    .footer {
      font-size: 12px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #CDCDCD;
      text-align: end;
      margin-top: 16px;
    }
  }
}
</style>
